import classNames from 'classnames'
import React from 'react'
import { NumberField, TextField } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { makeStyles } from 'tss-react/mui'
import { FastField, FormProps } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Theme } from '@mui/material'

import { FundingRoundTypeSelect } from '../Inputs'
import { FundingRoundFormData } from './FundingRoundForm.data'
import { IsCurrentRoundSwitch } from './IsCurrentRoundSwitch.component'

export type FundingRoundFormContentProps = ExtendableStyles & Testable & FormProps<FundingRoundFormData>

export function FundingRoundFormContent({
  className,
  'data-testid': dataTestId,
  style,
  values,
}: FundingRoundFormContentProps) {
  const { classes } = useStyles()
  const isCurrent = !values.announcedOn
  return (
    <div className={className} data-testid={dataTestId} style={style}>
      <div className={classNames(classes.groupFields, classes.field)}>
        <FastField className={classes.roundTypeSelector} component={FundingRoundTypeSelect} name="roundType" />
        <FastField label="Is current" component={IsCurrentRoundSwitch} />
      </div>
      {!isCurrent && (
        <div className={classes.doubleFieldWrapper}>
          <FastField
            component={TextField}
            label="Announced On"
            name="announcedOn"
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
          <FastField
            component={NumberField}
            label="Round Size"
            adornmentText="USD"
            name="roundSize"
            fullWidth
            internalInputProps={{ decimalScale: 0 }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>
      )}

      <div className={classes.doubleFieldWrapper}>
        <FastField
          component={NumberField}
          label="Target Money"
          adornmentText="USD"
          name="targetMoney"
          fullWidth
          internalInputProps={{ decimalScale: 0 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <FastField
          component={NumberField}
          label="Valuation pre money"
          adornmentText="USD"
          name="valuationPreMoney"
          fullWidth
          internalInputProps={{ decimalScale: 0 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>

      <FastField
        className={classes.field}
        component={TextField}
        label="Round terms"
        name="roundTerms"
        InputLabelProps={{ shrink: true }}
        multiline
        fullWidth
      />

      <FastField
        className={classes.field}
        component={TextField}
        label="Committed Investors"
        name="committedInvestors"
        InputLabelProps={{ shrink: true }}
        multiline
        fullWidth
      />
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  groupFields: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  roundTypeSelector: {
    flex: '1 1 auto',
    marginRight: spacing(),
  },
  doubleFieldWrapper: {
    display: 'grid',
    gridGap: spacing(),
    gridTemplateColumns: '1fr 1fr',
    marginBottom: spacing(2),
  },
  field: {
    marginBottom: spacing(2),
  },
}))
